import { render, staticRenderFns } from "./getBrandByXV.vue?vue&type=template&id=214de093&"
import script from "./getBrandByXV.vue?vue&type=script&lang=js&"
export * from "./getBrandByXV.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports